<template>
  <section class="max-w-md mx-auto">
    <div class="table-responsive">
      <table class="table w-full table-data min-w-table">
        <thead>
          <tr>
            <th v-text="'Add to Groups'" />
            <th v-text="'Remove from Groups'" />
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <MembershipGroupList :selected-membership-groups="add_to" />
            </td>
            <td>
              <MembershipGroupList :selected-membership-groups="remove_from" />
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th class="bg-grey-light border-grey-dark border-t">
              <button
                type="button"
                class="btn-sm block w-full btn--link btn"
                @click.prevent="openGroupSelectModal('add')"
                v-text="'Choose Groups To Add'"
              />
            </th>
            <th class="bg-grey-light border-grey-dark border-l border-t">
              <button
                type="button"
                class="btn-sm block w-full btn--link btn"
                @click.prevent="openGroupSelectModal('remove')"
                v-text="'Choose Groups To Remove'"
              />
            </th>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="mt-12 mb-6 flex justify-center">
      <button
        type="button"
        class="btn-sm btn--link btn mr-6"
        @click="previousTab"
        v-text="'Back'"
      />
      <button
        type="button"
        class="btn-sm btn-success btn"
        @click="nextTab"
        v-text="'Next'"
      />
    </div>
    <GroupSelectorModal
      :preselected-groups="preSelectedGroups"
      :show="showGroupSelectorModal"
      @close="showGroupSelectorModal = false"
      @updateSelectedGroups="handleSelectedGroup"
    />
  </section>
</template>

<script type="text/babel">
import TabNavigation from 'Membership/Resources/assets/js/mixins/tab-navigation'
import MembershipGroupList from './MembershipGroupList'

export default {
  name: 'SelectGroups',
  components: {
    MembershipGroupList,
  },
  mixins: [TabNavigation],
  data() {
    return {
      context: 'add',
      add_to: [],
      remove_from: [],
      showGroupSelectorModal: false,
    }
  },
  computed: {
    preSelectedGroups() {
      switch (this.context) {
        case 'add':
          return this.add_to
        case 'remove':
          return this.remove_from
        default:
          return []
      }
    },
  },
  methods: {
    handleSelectedGroup(payload) {
      switch (this.context) {
        case 'add':
          this.add_to = payload
          break
        case 'remove':
          this.remove_from = payload
      }

      this.$emit('updateSelectedGroups', {
        add_to: this.add_to,
        remove_from: this.remove_from,
      })
    },
    openGroupSelectModal(context) {
      this.context = context
      this.showGroupSelectorModal = true
    },
  },
}
</script>
